// src/pages/letterhead/utils/pdfGenerator.ts
import html2pdf from "html2pdf.js";
import { sendLetterEmailAPIHelper } from "../../../../Redux/helpers/letterheadAPI.ts";

export const generateAndSendPDF = async (finalLetterId: string, companyName: string, backendUrl: string, recipientName?: string, recipientEmail?: string, recipientAddress?: string) => {
    const elementToCapture = document.querySelector('.single-page-wrapper');
    if (!elementToCapture) throw new Error("Please enable 'Show' (Preview Mode) to generate the PDF attachment.");

    const clone = elementToCapture.cloneNode(true) as HTMLElement;
    clone.style.padding = "0px"; clone.style.margin = "0px";
    clone.querySelectorAll(".no-print, .sticky, h3, .modal-ui").forEach(node => node.remove());

    const container = document.createElement("div");
    container.style.cssText = `position: absolute; top: 0; left: 0; z-index: -9999; width: 794px; opacity: 0; pointer-events: none; background: white`;
    container.appendChild(clone);
    document.body.appendChild(container);

    const pages = clone.querySelectorAll(".single-page") as NodeListOf<HTMLElement>;
    pages.forEach((page, index) => {
        page.style.cssText = "margin: 0px; width: 794px; height: 1122px; min-width: 794px; min-height: 1122px; box-shadow: none; border-radius: 0px;";
        page.style.pageBreakAfter = index < pages.length - 1 ? "always" : "avoid";
    });

    const images = clone.querySelectorAll("img");
    await Promise.all(Array.from(images).map(async (img) => {
        if (img.src && !img.src.startsWith("data:")) {
            try {
                const proxyUrl = `${backendUrl}/api/letters/proxy-image?url=${encodeURIComponent(img.src)}`;
                const token = localStorage.getItem("token") || localStorage.getItem("authToken") || "";
                const response = await fetch(proxyUrl, { headers: { 'Authorization': `Bearer ${token}` } });
                if (response.ok) {
                    const data = await response.json();
                    if (data.base64) { img.src = data.base64; img.removeAttribute('crossorigin'); return Promise.resolve(); }
                }
                img.remove();
            } catch (e) { img.remove(); }
        }
        if (img.complete) return Promise.resolve();
        return new Promise((res) => { img.onload = res; img.onerror = () => { img.remove(); res(null); }; });
    }));

    const options = {
        margin: 0, filename: `Letter.pdf`, image: { type: "jpeg", quality: 0.90 },
        html2canvas: { scale: 1.5, useCORS: true, allowTaint: true, windowWidth: 794, windowHeight: 1123 },
        jsPDF: { unit: "px", format: [794, 1123], orientation: "portrait", compress: true }
    };

    const pdfBase64DataUri = await html2pdf().set(options).from(clone).output('datauristring');
    const pdfBase64 = pdfBase64DataUri.split(',')[1];
    document.body.removeChild(container);

    await sendLetterEmailAPIHelper(finalLetterId, {
        companyName,
        pdfBase64,
        recipient_name: recipientName,
        recipient_email: recipientEmail,
        recipient_address: recipientAddress
    });
};